import React from 'react';
import SubjectPage from '../../subjects/SubjectPage';

function NcertShortNote() {

  const pageTitleText = "NEET NCERT Short Notes ";


  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="ncert-short-note" 
        type="ncertshortnote"
      />

    </>
  );
}

export default NcertShortNote;